export enum ButtonSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}

export enum ButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  low = 'low',
  high = 'high',
  subtle = 'subtle'
}

export enum ButtonDisplay {
  ghost = 'ghost',
  contained = 'contained'
}

export type CssClassMap = { [className: string]: boolean };
